import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as THEMES from '../themes';
import * as _ from 'lodash';
import cssVars from 'css-vars-ponyfill';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ThemeSwitcherService {

    className = 'ThemeSwitcherService';
    isTablet;
    isTabletLandscape

    private currentTheme;

    private _subject: Subject<any>;
    observer: Observable<any>;

    constructor(private http: HttpClient,
        public breakpointObserver: BreakpointObserver) {
        this._subject = new Subject<any>();
        this.observer = this._subject.asObservable();
        this.breakpointObserver
            .observe([Breakpoints.Small, Breakpoints.Tablet, Breakpoints.TabletLandscape])
            .subscribe((state: BreakpointState) => {
                if (state.breakpoints[Breakpoints.TabletLandscape]) {
                    this.isTabletLandscape = true;
                    this.isTablet = true;
                } else if (state.matches) {
                    this.isTablet = true;
                    this.isTabletLandscape = false;
                } else {
                    this.isTablet = false;
                    this.isTabletLandscape = false;
                }
                this._subject.next({ isTablet: this.isTablet, isTabletLandscape: this.isTabletLandscape });
            });
    }

    changeTheme(theme) {
        let stylesheet: any = this.getStylesheet(theme);
        _.forIn(Breakpoints, (bp, bpName) => {
            _.set(stylesheet, `bp-${bpName}`, bp);
        })
        cssVars({
            shadowDOM: true,
            variables: stylesheet,
            watch: true
        });
        this.currentTheme = theme;
    }

    getStylesheet(theme) {
        return THEMES[theme];
    }

    getCurrentTheme() {
        return THEMES[this.currentTheme];
    }
}